import {
	Alert,
	AlertTitle,
	Box,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	listSysNotifications,
} from "../../actions/form";
import { ESRState } from "../../types/data";

import { useCurrentUser } from "../../hooks/useCurrentUser";
import {SystemNotificationRow} from "./SystemNotificationRow";

export const SystemNotifications = (): JSX.Element => {
	const dispatch = useDispatch();
	const [user, setUser] = useCurrentUser();
	const notifications = useSelector((state: ESRState) => state.system_notifications);
	const [notificationOrder, setNotificationsOrder] = useState<string[]>([]);
	const [alertOpen, setAlertOpen] = useState(true);
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const facets = useSelector((s: ESRState) => s.notifications_facets);
	const timerRef = useRef(-1);

	useEffect(() => {
		dispatch(listSysNotifications());
	}, []);

	useEffect(() => {
		const latestTimestamps = Object.entries(notifications).map(
			([receiver_id, notifications]) => {
				const latestNotification = notifications.reduce((latest, current) => {
					return latest.timestamp > current.timestamp ? latest : current;
				});
				return {
					receiver_id,
					timestamp: new Date(latestNotification.timestamp).getTime(),
				};
			},
		);
		latestTimestamps.sort((a, b) => {
			return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
		});
		setNotificationsOrder(latestTimestamps.map((item) => item.receiver_id));
	}, [notifications]);

	/**
	 * Load current notifications the user can see.
	 */
	return (
		<>
			<Box sx={{ display: "flex", height: "100%" }}>
				<Box
					sx={{
						flex: "auto",
						p: "60px 60px",
						height: "100%",
						boxSizing: "border-box",
						overflow: "scroll",
					}}
				>

					{alertOpen ? (
						<Alert
							icon={false}
							onClose={() => {
								setAlertOpen(false);
							}}
							sx={{ my: "30px", px: "40px" }}
							severity="warning"
						>
							<AlertTitle>
								Hi{user ? " " + user.first_name : ""}, today is{" "}
								{dayjs().format("MM/DD/YYYY")},{" "}
								{new Date().toLocaleDateString("en-US", {
									weekday: "long",
								})}
								.
							</AlertTitle>
							TREC recommends you take the following actions promptly.
						</Alert>
					) : null}
					{notificationOrder.map((rid) => (
						<SystemNotificationRow
							key={rid}
							rid={rid}
							notifications={notifications[rid]}
						/>
					))}
					<Box
						sx={{
							boxShadow: "-1px 0px 0px 0px rgba(0, 0, 0, 0.12)",
							display: sidebarOpen ? "block" : "none",
							width: 610,
							background: "#003E6205",
							p: "40px 22px",
						}}
					></Box>
				</Box>
			</Box>
		</>
	);
};
